import {gql} from "@apollo/client";
import { client } from "graphql/client";

// 创建配置管理员角色
export const CREATE_ACCOUNT_CONFIG_ADMIN = gql`
    mutation CreateAccountConfigAdmin($input: AccountConfigAdminInput!) {
        createAccountConfigAdmin(input: $input)
    }
`;

// 更新配置管理员角色
export const UPDATE_ACCOUNT_CONFIG_ADMIN = gql`
    mutation UpdateAccountConfigAdmin($input: AccountConfigAdminInput!) {
        updateAccountConfigAdmin(input: $input)
    }
`;

// 入参 用于前端调用 GraphQL mutation 时传递参数，确保前端传递的参数结构与后端 GraphQL schema 一致
export interface AccountConfigAdminInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
    role: string;
}

export const createAccountConfigAdmin = async (input: AccountConfigAdminInput): Promise<boolean> => {
        const {data} = await client.mutate({
            mutation: CREATE_ACCOUNT_CONFIG_ADMIN,
            variables: {input}
        });
        return data.createAccountConfigAdmin;
};

export const updateAccountConfigAdmin = async (input: AccountConfigAdminInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: UPDATE_ACCOUNT_CONFIG_ADMIN,
        variables: {input}
    });
    return data.updateAccountConfigAdmin;
};

